import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { agentClient } from '../client';

export let agentTemplatesLoader = createLoader({
  name: 'agent_templates',
  fetch: (i: {}) =>
    withAuth(() =>
      agentClient.template.list({
        ...i,
        limit: 10,
        order: 'desc'
      })
    ),
  mutators: {}
});

export let useAgentTemplates = () => {
  let templates = agentTemplatesLoader.use({});

  return templates;
};

export let agentTemplateLoader = createLoader({
  name: 'agent_template',
  fetch: (i: { templateId: string }) => withAuth(() => agentClient.template.get(i)),
  mutators: {
    createAgentFromTemplate: (d: { templateId: string; instanceId: string }) => {
      console.log(d);
      return withAuth(() => agentClient.template.createAgentFromTemplate(d));
    }
  }
});

export let useAgentTemplate = (templateId?: string | null) => {
  let template = agentTemplateLoader.use(templateId ? { templateId } : null);

  return {
    ...template,
    createAgentFromTemplateMutator: template.useMutator('createAgentFromTemplate')
  };
};
